import { Component, Inject, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GeneralSnack } from '../../models/components-general/general-snack.model';

@Component({
  selector: 'app-general-snack',
  standalone: true,
  imports: [CommonModule, MatSnackBarModule, MatIconModule, TranslateModule],
  templateUrl: './general-snack.component.html',
  styleUrl: './general-snack.component.scss',
})
export class GeneralSnackComponent {
  public snackBarRef = inject(MatSnackBarRef);
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: GeneralSnack) {}
}
